import { render } from "./VideoRealtime.vue?vue&type=template&id=b158fe96&scoped=true"
import script from "./VideoRealtime.vue?vue&type=script&lang=ts"
export * from "./VideoRealtime.vue?vue&type=script&lang=ts"

import ".././assets/styles/videoRealtime.css?vue&type=style&index=0&lang=css"
import "./VideoRealtime.vue?vue&type=style&index=1&id=b158fe96&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b158fe96"

export default script